import run from '../../utilities/run';
import $ from 'jquery';
import PagableComponent from "../../components/pagableComponent/index.js";
const renderTemplateForProductsHtml = require("./html/renderTemplateForProducts.html");
const renderTemplateForOrdersHtml = require("./html/renderTemplateForOrders.html");
const renderTemplateForBundlesHtml = require("./html/renderTemplateForBundles.html");
const renderTemplateForAMLHtml = require("./html/renderTemplateForAML.html");
const renderTemplateForRMAHtml = require("./html/renderTemplateForRMA.html");
const renderTemplateForRulesHtml = require("./html/renderTemplateForRules.html");
//import {initialDataForProducts} from "./initialDetails";
import render from "../../utilities/render";
import {doAjax} from "../../utilities/filtersutil";
import SUCCESS_MODAL_TIMEOUT from "../../constants/index.js";
import {buildExport,readSpecificObjectFromCurrentData,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
run("#bulkUpload-details-page", ()=> {
	const outerEl = $("#bulkUpload-details-page");
	const downloadBtn = $("#download_error-btn");
	const downloadBtnUrl = outerEl.data("download-error-url");
	const filterURL = outerEl.data("filter-url");
	const filterOrderURL= outerEl.data("filter-order-url");
	const filterAmlURL= outerEl.data("filter-aml-url");
	const filterRMAURL= outerEl.data("filter-rmas-url");
	const filterRuleURL= outerEl.data("filter-rule-url");
	const downloadForm =  $("#bulk-details-form");
	const loadMoreBtn = $("#load_more-btn");
	const loadItemUrl = outerEl.data("load-more-item-url");
	const viewItemUrl = outerEl.data("view-item-url");
	const viewOrderReleaseRuleUrl = outerEl.data("view-release-rule-url");
	const viewBundleUrl = outerEl.data("view-bundle-url");
	const viewOrderRenderUrl = outerEl.data("view-order-render-url");
	const viewRMAUrl = outerEl.data("view-rma-url");
	let nextPage =  outerEl.data("next-page-value");
	const bulkproductuuidjson=outerEl.data("bulkproductuuidjson");
	const bulkorderuuidjson=outerEl.data("bulkorderuuidjson");
	const bulkamluuidjson=outerEl.data("bulkamluuidjson");
	const bulkruleuuidjson=outerEl.data("bulkruleuuidjson");
	const bulkrmauuidjson=outerEl.data("bulkrmauuidjson");
	const bupuuid=outerEl.data("bupUuId");
	//Changes for 7674
	let exportModal = new buildExport();
	const generateExportProductsUrl  =  outerEl.data("export-products-url");
	const portletNamespace =  outerEl.data("portlet-namespace");
	const entityType=outerEl.data("entity-type");
	//integration for order export
	const generateExportOrdersUrl  =  outerEl.data("export-orders-url");
	const generateExportAMLUrl = outerEl.data("export-aml-url");
	const generateExportOrderRelaseRulesUrl = outerEl.data("export-order-relese-rule-url");
	const generateExportRMAUrl = outerEl.data("export-rma-url");
	let totalCount;
	let generateExportUrl;
	let title;
	if (entityType  ===  "Products") {
		generateExportUrl = generateExportProductsUrl;
		title = "Products Export";
	}
	else  if (entityType  ===  "Orders") {
		generateExportUrl = generateExportOrdersUrl;
		title = "Order Export";
	}
	else  if (entityType  ===  "Bundles") {
		generateExportUrl = generateExportProductsUrl;
		title = "Bundles Export";
	} 	
	else  if (entityType  ===  "AML") {
		generateExportUrl = generateExportAMLUrl;
		title = "AML Export";
	}
	else  if (entityType  ===  "RMA") {
		generateExportUrl = generateExportRMAUrl;
		title = "RMA Export";
	}
	else  if (entityType  ===  "Order Release Rules") {
		generateExportUrl = generateExportOrderRelaseRulesUrl;
		title = "Order Release Rules Export";
	}
	showHideLoadButton(nextPage);
		function showHideLoadButton (nextPage){
		if(!nextPage){
			loadMoreBtn.hide();
		}else{
			loadMoreBtn.show();
		}
	}


	downloadBtn.click(function() {
		//outerEl.preventDefault();
		downloadForm.attr('method', 'post');
		downloadForm.attr('action', downloadBtnUrl);
		downloadForm.attr('target', 'bulk-details-error');
		downloadForm.submit();
	});

	
	if(entityType == 'AML') {
	const pagableAML = new PagableComponent({
		dataContainer:'.aml-list',
		pagingContainer:'.paging-area-for-aml',
		data:bulkamluuidjson,
		showData: function(row){
			return render(renderTemplateForAMLHtml, {
				itemSku:row.amlItemSku,
				soldToParty: row.amlCustomerId,
				amlStatus: getAuthorizedStatus(row.amlStatus),
			});
		},
		onFetch: function(page, pageSize){
			pagableAML.showLoadingOverlay();
			setTimeout(() => {
				doAjax({url: filterAmlURL, success: filterSuccess, error: error, data:prepareDataToSendController(bupuuid,page, pageSize)});
			},SUCCESS_MODAL_TIMEOUT);
		}
	});
	pagableAML.init();

	function getAuthorizedStatus(amlStatus) {
		if(amlStatus == 'A') {
			return "Authorized"
		} else {
			return "Unauthorized"
		}
	}

	function filterSuccess(data)
	{
		let aml = data.content;
		pagableAML.setData(aml);
		pagableAML.hideLoadingOverlay();

	}

	function error(data){
		pagableAML.hideLoadingOverlay();
	}
	function prepareDataToSendController(bupuuid,page,pageSize){
		let data={
			page:page,
			pageSize:pageSize,
			buid:bupuuid
		}
		return data;
	}
}

if(entityType == 'Order Release Rules') {
	const pagableRules = new PagableComponent({
		dataContainer:'.rules-list',
		pagingContainer:'.paging-area-for-rules',
		data:bulkruleuuidjson,
		showData: function(row){		
			return render(renderTemplateForRulesHtml, {
				
				itemSku:row.sku,
				ruleId: row.ruleId,
				viewItemUrl:viewOrderReleaseRuleUrl,
			});
		},
		onFetch: function(page, pageSize){
			pagableRules.showLoadingOverlay();
			setTimeout(() => {
				doAjax({url: filterRuleURL, success: filterSuccess, error: error, data:prepareDataToSendController(bupuuid,page, pageSize)});
			},SUCCESS_MODAL_TIMEOUT);
		}
	});
	pagableRules.init();


	function filterSuccess(data)
	{
		let rule = data.content;
		pagableRules.setData(rule);
		pagableRules.hideLoadingOverlay();

	}

	function error(data){
		pagableRules.hideLoadingOverlay();
	}
	function prepareDataToSendController(bupuuid,page,pageSize){
		let data={
			page:page,
			pageSize:pageSize,
			buid:bupuuid
		}
		return data;
	}
}

  if(entityType == 'Products'){
  	totalCount = bulkproductuuidjson.totalElements;
  const pageSizeOptions = [10,25,50,100];
	const pagableProducts = new PagableComponent({
		dataContainer:'.product-list',
		pagingContainer:'.paging-area-for-products',
		pageSizeOptions: pageSizeOptions,
		pageSize: 10,
		data:bulkproductuuidjson,
		showData: function(row){
			return render(renderTemplateForProductsHtml, {
				sku: row.itmSku,
				prdsku:row.itmSku,
				prdactive: row.itmActive,
				itmid:row.itmId,
				viewItemUrl:viewItemUrl
			});
		},
		onFetch: function(page, pageSize){
			pagableProducts.showLoadingOverlay();
			setTimeout(() => {
				doAjax({url: filterURL, success: filterSuccessFun, error: errorFun, data:prepareDataToSendController(bupuuid,page, pageSize)});
			},SUCCESS_MODAL_TIMEOUT);
		}
	});
	pagableProducts.init();

	function filterSuccessFun(data)
	{
		let product = data.content;
		pagableProducts.setData(product);
		pagableProducts.hideLoadingOverlay();

	}

	function errorFun(data){
		pagableProducts.hideLoadingOverlay();
	}
	function prepareDataToSendController(bupuuid,page,pageSize){
		let data={
			page:page,
			pageSize:pageSize,
			buid:bupuuid
		}
		return data;
	}
}

	if (entityType == 'Bundles') {
		totalCount = bulkproductuuidjson.totalElements;
		const pageSizeOptions = [10, 25, 50, 100];
		const pagableProducts = new PagableComponent({
			dataContainer: '.bundles-list',
			pagingContainer: '.paging-area-for-products',
			pageSizeOptions: pageSizeOptions,
			pageSize: 10,
			data: bulkproductuuidjson,
			showData: function (row) {
				return render(renderTemplateForBundlesHtml, {
					sku: row.itmSku,
					prdsku: row.itmSku,
					prdactive: renderStatusPill(row.itmActive),
					itmid: row.itmId,
					viewItemUrl: viewBundleUrl
				});
			},
			onFetch: function (page, pageSize) {
				pagableProducts.showLoadingOverlay();
				setTimeout(() => {
					doAjax({ url: filterURL, success: filterSuccessFun, error: errorFun, data: prepareDataToSendController(bupuuid, page, pageSize) });
				}, SUCCESS_MODAL_TIMEOUT);
			}
		});
		pagableProducts.init();

		function filterSuccessFun(data) {
			let product = data.content;
			pagableProducts.setData(product);
			pagableProducts.hideLoadingOverlay();

		}

		function errorFun(data) {
			pagableProducts.hideLoadingOverlay();
		}
		function prepareDataToSendController(bupuuid, page, pageSize) {
			let data = {
				page: page,
				pageSize: pageSize,
				buid: bupuuid
			}
			return data;
		}
	}


	if(entityType == 'Orders'){
	//HB-7939-pagination for bulk-upload-orders

	const orderBulkData = {
	totalElements: bulkorderuuidjson.pagination.totalElements,
	totalPages: bulkorderuuidjson.pagination.totalPages,
	size:bulkorderuuidjson.pagination.size,
	page: bulkorderuuidjson.pagination.number,
	content:bulkorderuuidjson.orders
	}
	totalCount = orderBulkData.totalElements;
	const pageSizeOptions = [10,25,50,100];
	const pagableOrder = new PagableComponent({
		dataContainer:'.orders-list',
		pagingContainer:'.paging-area-for-orders',
		pageSizeOptions: pageSizeOptions,
		pageSize: 10,
		data:orderBulkData,
		showData: function(row){
        let pillColor = getOrderStatusPillColor(row.ordStatus);
				return render(renderTemplateForOrdersHtml, {
				externalOID:row.externalOrderId,
				fedexOId:row.fedexOrderId,
        pillColor:pillColor,
				status:row.ordStatus,
				viewOrderRenderUrl:viewOrderRenderUrl

			});
		},
		onFetch: function(page, pageSize){
			pagableOrder.showLoadingOverlay();
			setTimeout(() => {
				doAjax({url: filterOrderURL, success: filterorderSuccessFun, error: ordererrorFun, data:prepareDataToSendOrderController(bupuuid,page, pageSize)});
			},SUCCESS_MODAL_TIMEOUT);
		}
	});
	pagableOrder.init();

 function getOrderStatusPillColor(status) {
   if (status === "Error") {
     return "q-pill-red";
   } else if (status === "Shipped") {
     return "q-pill-blue";
   } else if (status === "In Process") {
     return "q-pill-blue-border";
   } else if (status === "Released") {
     return "q-pill-blue-border";
   } else if (status === "Partially Shipped") {
     return "q-pill-blue-border";
   } else if (status === "Pending") {
     return "q-pill-blue-border";
   } else if (status === "Backordered") {
     return "q-pill-red";
   } else if (status === "Partially Released") {
     return "q-pill-blue-border";
   } else if (status === "Self Fulfill") {
     return "q-pill-blue";
   } else if (status === "Held") {
     return "q-pill-blue-border";
   } else if (status === "Hold Pending") {
     return "q-pill-blue-border";
   } else if (status === "Canceled") {
     return "q-pill-light-grey";
   } else if (status === "Cancel Pending") {
     return "q-pill-light-grey";
   }
 }

	function filterorderSuccessFun(data)
	{
		let order = data.orders;
		pagableOrder.setData(order);
		pagableOrder.hideLoadingOverlay();

	}

	function ordererrorFun(data){
		pagableOrder.hideLoadingOverlay();
	}

	function prepareDataToSendOrderController(bupuuid,page,pageSize){
		let data={
			page:page,
			pageSize:pageSize,
			buid:bupuuid
		}
		return data;
	}
}

if(entityType == 'RMA'){
	totalCount = bulkrmauuidjson.totalElements;
  const pageSizeOptions = [10,25,50,100];
  const pagableRmas = new PagableComponent({
	  dataContainer:'.rma-list',
	  pagingContainer:'.paging-area-for-rma',
	  pageSizeOptions: pageSizeOptions,
	  pageSize: 10,
	  data:bulkrmauuidjson,
	  showData: function(row){
		return render(renderTemplateForRMAHtml, {
			selectedRmaId:row.rmaId,
			rmaNumber:row.rmaNumber,
			status:row.rmaStatus,
			viewRmaRenderUrl:viewRMAUrl
		});
	  },
	  onFetch: function(page, pageSize){
		  pagableRmas.showLoadingOverlay();
		  setTimeout(() => {
			  doAjax({url: filterRMAURL, success: filterRmaSuccessFun, error: rmaerrorFun, data:prepareDataToSendRmaController(bupuuid,page, pageSize)});
		  },SUCCESS_MODAL_TIMEOUT);
	  }
  });
  pagableRmas.init();

  function filterRmaSuccessFun(data)
  {
	  let rma = data.content;
	  pagableRmas.setData(rma);
	  pagableRmas.hideLoadingOverlay();

  }

  function rmaerrorFun(data){
	  pagableRmas.hideLoadingOverlay();
  }
  function prepareDataToSendRmaController(bupuuid,page,pageSize){
	  let data={ 
		  page:page,
		  pageSize:pageSize,
		  buid:bupuuid,  
	  }
	  return data;
  }
}
	//Export button integration functionality
	function initExport() {
		const cssClassNameForCount = "exportCountCSS";
		let exportObj  =  {
			title : title,
			exportAttemptTextPart1Lang: outerEl.data("export-attempt-text-part1"),
			exportAttemptTextPart2Lang: outerEl.data("export-attempt-text-part2"),
			exportMaxLimitLang: outerEl.data("export-max-row-limit"),
			cssClassNameForCount:cssClassNameForCount
		};
		exportModal.init(exportObj);
		exportModal.bindExportEvent();
	}

	function setExportData(currentData) {
		exportModal.buildExportCustomBasicURL(generateExportUrl,currentData,portletNamespace);
		let url = exportModal.getCurrentUrl();
		url =  url+bupuuid;
		exportModal.buildExportCustomBasicURL(url,currentData,portletNamespace);
		exportModal.setExportCount(totalCount,"exportCountCSS");
	}

	let currentData = {};
	initExport();
	setExportData(currentData);

	function renderStatusPill(status){
		if(status =true){
			return "Active";
		}else{
			return "Deactive";
		}
	}
	
});



// WEBPACK FOOTER //
// ./src/pages/bulkUpload/bulkUploadDetails.js